import React, { useEffect, useState } from 'react'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
import { v4 as uuidv4 } from 'uuid'
import CreateMovieandPersonList from '../../Services/Mutations/CreateMovieandPersonList'
import { Auth } from 'aws-amplify'
import GetMovie from '../../Services/Queries/GetMovie'
// import GetPerson from '../../Services/Queries/GetPerson'
import MoveUpDownData from './MoveUpDownData'
import UpdateMovieListData from './UpdateMovieListData'
import SubmitEditList from './SubmitEditList'
import TaggedPersonsUI from './TaggedPersonsUI'

export default function TaggedmoviePersonandSearch(props) {
  const {
    selectedListType,
    listData,
    editMode,
    sendLoadSpinner,
    MOvieListId,
    // initialAllTaggedPersons,
    clearAll,
    setListId,
    imagePreview,
    createListValidation,
    valueEdited,
    setvalueEdited,
    selectedMovieOrPersonData,
    setSelectedMovieOrPersonData,
  } = props
  const [searchBarVisible, setSearchBarVisible] = useState(false)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [editIndexes, setEditIndexes] = useState([])
  const [allTaggedPersons, setAllTaggedPersons] = useState([])
  const [movieAlreadyAdded, setmovieAlreadyAdded] = useState(false)

  const toggleSearchBar = async () => {
    if (selectedListType === 'Text') {
      const randomId = await uuidv4()
      if (selectedMovieOrPersonData.length === 0) {
        setSelectedMovieOrPersonData([
          { PK: randomId, SK: randomId, listItemDescription: '', listItemDescription_Te: '' },
        ])
      } else {
        setSelectedMovieOrPersonData([
          ...selectedMovieOrPersonData,
          { PK: randomId, SK: randomId, listItemDescription: '', listItemDescription_Te: '' },
        ])
      }
    } else {
      setSearchBarVisible(!searchBarVisible)
      setAutoSuggestions([])
    }
  }

  const handleSelectAutoSuggestion = async suggestionIndex => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    if (selectedMovieOrPersonDataTemp.length >= 1) {
      setmovieAlreadyAdded(
        selectedMovieOrPersonDataTemp.some(item => item.PK === autoSuggestions[suggestionIndex].PK),
      )
    }

    if (
      selectedMovieOrPersonDataTemp.every(item => item.PK !== autoSuggestions[suggestionIndex].PK)
    ) {
      try {
        let movieOrPersonDataResponse = {}
        if (selectedListType === 'Movie') {
          const input = { movieID: autoSuggestions[suggestionIndex].PK }
          movieOrPersonDataResponse = await GetMovie(input)
        }

        let allPersons = []
        if (selectedListType === 'Movie') {
          if (movieOrPersonDataResponse.Crew) {
            allPersons = [...allPersons, ...movieOrPersonDataResponse.Crew]
            autoSuggestions[suggestionIndex].taggedPersons = allPersons
          }

          if (movieOrPersonDataResponse.Cast) {
            allPersons = [...allPersons, ...movieOrPersonDataResponse.Cast]
            autoSuggestions[suggestionIndex].taggedPersons = allPersons
          }
        } else {
          autoSuggestions[suggestionIndex].taggedPersons = []
        }

        let finalTaggedPersons = []
        if (editMode === 'edit') {
          finalTaggedPersons = [[...allTaggedPersons, ...allPersons].flat(1)]
        } else {
          finalTaggedPersons = [...allTaggedPersons, allPersons]
        }

        sendTaggedPersons(finalTaggedPersons)
      } catch {}

      selectedMovieOrPersonDataTemp.push(autoSuggestions[suggestionIndex])
      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    }
  }

  const sendTaggedPersons = data => {
    setAllTaggedPersons(data)
  }

  useEffect(() => {
    setSelectedMovieOrPersonData(props.editListData ? props.editListData : [])
    // setAllTaggedPersons(props.TaggedpersonsFromService ? [props.TaggedpersonsFromService] : [])
  }, [props.editListData])
  const searchMoviePerson = async value => {
    if (value === '') {
      setAutoSuggestions([])
    }

    try {
      if (value.length >= 3) {
        const input = {
          search: value,
          type: selectedListType === 'Movie' ? 'movie' : 'person',
          limit: 100,
          from: 0,
        }
        const searchedData = await AutoSuggestions(input)
        if (selectedListType === 'Movie') {
          const movieData = searchedData.movieHits ? searchedData.movieHits : []
          setAutoSuggestions(
            movieData
              ? movieData.map(movieItem => ({
                  ...movieItem,
                  label: movieItem.title_En,
                  poster: movieItem.posterURL,
                  listItemDescription: '',
                  listItemDescription_Te: '',
                }))
              : [],
          )
        } else {
          const personData = searchedData.personHits ? searchedData.personHits : []
          setAutoSuggestions(
            personData
              ? personData.map(personItem => ({
                  ...personItem,
                  label: personItem.name_En,
                  poster: personItem.posterURL,
                  listItemDescription: '',
                  listItemDescription_Te: '',
                }))
              : [],
          )
        }
      }
    } catch {
      setAutoSuggestions([])
    }
  }

  const handleChangeDescription = (value, data) => {
    const { dataIndexItemDiscription, text, lang } = data

    if (text === 'about') {
      const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
      selectedMovieOrPersonDataTemp[dataIndexItemDiscription][`about_${lang}`] = value
      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    } else {
      const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
      selectedMovieOrPersonDataTemp[dataIndexItemDiscription][
        lang === 'En' ? 'listItemDescription' : 'listItemDescription_Te'
      ] = value

      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    }
  }

  const handleEdit = (index, dataItem) => {
    let editIndexesTemp = [...editIndexes]
    if (editIndexesTemp.includes(dataItem)) {
      editIndexesTemp = editIndexesTemp.filter(item => item !== dataItem)
    } else {
      editIndexesTemp.push(dataItem)
    }

    setEditIndexes(editIndexesTemp)
  }

  const handleDelete = index => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    const taggedPersonsTemp = [...allTaggedPersons]
    if (editMode === 'edit') {
      const movieperson = selectedMovieOrPersonDataTemp.splice(index, 1)

      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
      const tempArray = taggedPersonsTemp.flat(1)
      const removedArray = tempArray.filter(
        el => !movieperson[0].taggedPersons.find(rm => rm.personID === el.personID),
      )

      setAllTaggedPersons([removedArray])
    } else {
      selectedMovieOrPersonDataTemp.splice(index, 1)
      taggedPersonsTemp.splice(index, 1)
      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
      setAllTaggedPersons(taggedPersonsTemp)
    }
  }

  const handleMoveItem = async (position, index) => {
    const moveDataInput = { position, index, selectedMovieOrPersonData, allTaggedPersons }
    const positionedDataResponse = await MoveUpDownData(moveDataInput, editMode)

    setSelectedMovieOrPersonData(positionedDataResponse[0])
    setAllTaggedPersons(positionedDataResponse[1])
  }

  const SubmitCreateList = async () => {
    let loggedInUserHandle = ''
    const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
    if (loggedInUserEmail) {
      const emailParams = loggedInUserEmail.split('@')
      loggedInUserHandle = '@' + emailParams[0]
    }

    let createListInput = {}
    const randomId = await uuidv4()

    try {
      createListInput = {
        createdByHandle: loggedInUserHandle,
        createdByID: Auth.user.username,
        description_En: listData.description_en,
        description_Te: listData.description_te,
        movieListCategory: selectedListType,
        movieListType: 'Editorial',
        movieListID: MOvieListId ? MOvieListId : randomId,
        title_En: listData.title_en,
        title_Te: listData.title_te,
        movieListImage: imagePreview,
      }
      setListId(MOvieListId ? MOvieListId : `movieList#${randomId}`)

      if (editMode === 'edit') {
        SubmitEditList(
          {
            createListInput,
            selectedMovieOrPersonData,
          },
          clearAll,
        )
      } else {
        const responseCreate = await CreateMovieandPersonList(createListInput)
        if (responseCreate.statusCode === 'M200' && selectedMovieOrPersonData.length === 0) {
          setTimeout(() => {
            clearAll(MOvieListId ? MOvieListId : `movieList#${randomId}`)
          }, 3000)
        }

        if (responseCreate.statusCode === 'M200' && selectedMovieOrPersonData.length >= 1) {
          const responseUploadData = await UpdateMovieListData(
            selectedListType,
            randomId,
            selectedMovieOrPersonData,
          )

          if (responseUploadData.statusCode === 'M207') {
            setTimeout(() => {
              clearAll(MOvieListId ? MOvieListId : `movieList#${randomId}`)
            }, 3000)
          }
        }
      }
    } catch {}
  }

  return (
    <TaggedPersonsUI
      allTaggedPersons={allTaggedPersons}
      searchBarVisible={searchBarVisible}
      toggleSearchBar={toggleSearchBar}
      createListValidation={createListValidation}
      listData={listData}
      imagePreview={imagePreview}
      selectedListType={selectedListType}
      searchMoviePerson={searchMoviePerson}
      autoSuggestions={autoSuggestions}
      handleSelectAutoSuggestion={handleSelectAutoSuggestion}
      selectedMovieOrPersonData={selectedMovieOrPersonData}
      handleDelete={handleDelete}
      movieAlreadyAdded={movieAlreadyAdded}
      editIndexes={editIndexes}
      handleChangeDescription={handleChangeDescription}
      handleMoveItem={handleMoveItem}
      handleEdit={handleEdit}
      sendTaggedPersons={sendTaggedPersons}
      editMode={editMode}
      SubmitCreateList={SubmitCreateList}
      sendLoadSpinner={sendLoadSpinner}
      setSelectedMovieOrPersonData={setSelectedMovieOrPersonData}
      valueEdited={valueEdited}
      setvalueEdited={setvalueEdited}
    />
  )
}
